import ENVIRONMENT from './enviroment';

export default ENVIRONMENT;
